import { Fragment } from "react";
import PropTypes from "prop-types";
import { map } from "lodash";
import preventDefault from "../../../helpers/components/preventDefault";
import { navigate } from "../../../helpers/tixxt-router";

function FolderInfo({
  id,
  name,
  type,
  profile,
  navigateDisabled,
  handleNavigate,
  noExtraColspan,
  extraColumns,
  context,
  contextUrl,
}) {
  const folderPath =
    type === "activitystream_folder"
      ? `${contextUrl || ""}/files/activitystream_folders/${id}`
      : `${contextUrl || ""}/files/folders/${id}`;

  return (
    <Fragment>
      <td className="col-name p-2">
        {navigateDisabled ? (
          <span className="text-muted">{name}</span>
        ) : (
          <a
            href={handleNavigate && context === "modal" ? "#" : folderPath}
            onClick={
              context === "modal"
                ? preventDefault(() => handleNavigate())
                : (e) => {
                    e.preventDefault();
                    navigate(folderPath, { replace: true });
                  }
            }
            data-id={id}
            data-type={type}
          >
            {name}
          </a>
        )}
      </td>
      {map(extraColumns, ({ Data }, i) => (
        <Data key={i} profile={profile} />
      ))}
      {noExtraColspan ? null : <td colSpan={4} />}
    </Fragment>
  );
}

FolderInfo.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  profile: PropTypes.object,
  navigateDisabled: PropTypes.bool,
  handleNavigate: PropTypes.func,
  noExtraColspan: PropTypes.bool,
  extraColumns: PropTypes.arrayOf(
    PropTypes.shape({
      Header: PropTypes.func.isRequired,
      Data: PropTypes.func.isRequired,
    }),
  ),
  contextUrl: PropTypes.string,
};

export default FolderInfo;
